<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper1.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="1" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <img style="height: 100px;" src="../../../static/images/logo.png"/>
        <p style="text-indent:2em;">
          杭州盛弘检测科技有限公司创办于2021年8月，注册资金500万，其中固定资产200多万元，是专业技术服务机构，具有独立的法人资格。
        </p>
        <p style="text-indent:2em;">
          公司目前的主要业务包括：职业病危害检测与评价、安全技术服务、环保技术服务等。
        </p>
        <p style="text-indent:2em;">
          公司现有专业技术人员30人，其中高级工程师3人、中级以上技术人员10人，公司全部员工均具有大学专科以上文化程度。
        </p>
        <p style="text-indent:2em;">
          公司拥有固定的办公场所，办公场所面积1000平方米，其中实验区约500平方米。
        </p>
        <p style="text-indent:2em;">
          公司设有质管部、检测部、职评部、办公室等多个部门。是一支年青化、素质高、技能强、敬业好的专业技术队伍。
        </p>
        <p style="text-indent:2em;">
          同时公司现已配备了气相色谱仪、原子吸收分光光度计、紫外可见分光光度计、十万分之一电子天平、万分之一电子天平等大型精密仪器设备，并配备有烘箱、冷藏箱等辅助设备，确保了监测工作的准确性、科学性、权威性。检测能力覆盖矿山，化工、石化、医药，冶金、建材，机械制造、电力、纺织、建筑和交通运输等行业领域。
        </p>
        <p style="text-indent:2em;">
          公司始终坚持“科学、公正、准确、高效、规范”的质量方针，公司宗旨是对社会和顾客高度负责，提供权威、公正、科学的报告，让社会和顾客持续满意。
        </p>
        <p style="text-indent:2em;">
          公司地址：浙江省杭州市临平区星桥街道星桥北路64号4幢601室
        </p>
        <p style="text-indent:2em;">
          联系方式：0571-89150039
        </p>
        <p style="text-indent:2em;">
          邮政编号：311100
        </p>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      menuchild:[{
        lable:'公司简介',
        value:'1',
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'关于盛弘',
        path:'',
      },{
        lable:'公司简介',
        path:'',
      }]
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .aboutus_content{
      width: 1200px;
      padding:60px 0;
      font-size: 15px;
      color: #666;
      line-height: 40px;
      // background: url('../../../static/images/onlylogo.png') ;
      // background-repeat: no-repeat;
      // background-position: center;
      // background-size: auto 100%;
      // background-color: rgba(255, 255, 255, 0.1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/concerning/aboutUs.vue